import * as React from "react";

import { PageProviderContext } from "@/components/page-provider/page-provider-component";

export default function usePage() {
  return React.useContext(PageProviderContext);
}
